// extracted by mini-css-extract-plugin
module.exports = {"vote-date-container":"aSKOXDQ","voteDateContainer":"aSKOXDQ","yearBlock":"_3vJMkKu","item":"_3Wc3e9J","pastVoteItemsList":"fETgABS"};